import parse from 'html-react-parser';

type Props = {
  heading: string;
  insetContent: string | undefined;
};

function Inset({ insetContent }: Props) {
  return <div className="govuk-inset-text">{parse(insetContent || '')}</div>;
}

export default Inset;
